import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './CertificatePage.module.css';
import SustainabilityQuestionnaire from './SustainabilityQuestionnaire';

function CertificatePage() {
  const location = useLocation();
  const { certificate: initialCert, questionnaireData } = location.state || {};
  const [report, setReport] = useState(initialCert || '');
  const [loading, setLoading] = useState(!!questionnaireData);
  const [error, setError] = useState('');
  const [tab, setTab] = useState(0);

  useEffect(() => {
    if (!questionnaireData) {
      // Dummy certificate when no data provided
      const dummy = `Suspire Sustainability Report: Dummy Brand\n\nFinal Score: 8.5 / 10 (Very Good)\nDate of Evaluation: June 3, 2025\n\nSummary:\n- 100% plant-based materials\n- No renewable energy usage\n- Limited packaging recycling\n\nScore by Category:\nMaterials & Ingredients: 20/20\nPackaging & Waste: 10/15\nSourcing & Supply Chain: 12/15\nEthical Labor Practices: 13/15\nRenewable Energy & Emissions: 0/10\nCommunity & Give Back: 8/10\nCertifications & Transparency: 4/5\nBonus (Workplace): 3/5\n\nKey Recommendations:\nShort-Term: Implement renewable energy pilots\nLong-Term: Shift to carbon-neutral shipping\nCertifications to Pursue: GOTS, B Corp`;
      setReport(dummy);
      setLoading(false);
      return;
    }
    // Call LLM for real evaluation
    setLoading(true);
    const userContent = JSON.stringify(questionnaireData, null, 2);
    fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages: [
          { role: 'system', content: `🧠 INSTRUCTIONS FOR AN LLM EVALUATOR\n+When an LLM evaluates a completed Suspire form:\n+A. SCORING: assign points per rubric, penalize missing/vague, cap at 100, map to 1–10.\n+B. OUTPUT: final score, breakdown table, highlights, recommendations, SDG alignment, eligibility.\n+Use this instruction exactly.` },
          { role: 'user', content: userContent }
        ],
        max_tokens: 1000
      })
    })
      .then((res) => res.json())
      .then((data) => {
        const ai = data.choices?.[0]?.message?.content || 'No evaluation returned.';
        setReport(ai);
      })
      .catch((err) => setError('Failed to evaluate certificate'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.tabs}>
        <button
          className={tab === 0 ? styles.activeTab : styles.inactiveTab}
          onClick={() => setTab(0)}
        >
          Sustainability Questionnaire
        </button>
        <button
          className={tab === 1 ? styles.activeTab : styles.inactiveTab}
          onClick={() => setTab(1)}
        >
          Certificate Demo
        </button>
      </div>
      <div style={{ width: '100%'}}>
        {tab === 0 && (
          <div className={styles.questionnaireWrapper}>
            <SustainabilityQuestionnaire isDemoMode />
          </div>
        )}
        {tab === 1 && (
          <div className={styles.certificateContent}>
            {questionnaireData ? (
              <pre className={styles.certificateReport}>{report}</pre>
            ) : (
              <div className={styles.dummyCertificate}>
                <h2>Suspire Sustainability Report: Dummy Brand</h2>
                <h3>Final Score: 8.5 / 10 (Very Good)</h3>
                <p className={styles.date}>Date of Evaluation: June 3, 2025</p>
                <hr />
                <h4>Summary</h4>
                <ul className={styles.summaryList}>
                  <li>✅ 100% plant-based materials</li>
                  <li>🚩 No renewable energy usage</li>
                  <li>🚩 Limited packaging recycling</li>
                </ul>
                <h4>Score by Category</h4>
                <table className={styles.scoreTable}>
                  <tbody>
                    <tr><th>Materials & Ingredients</th><td>20/20</td></tr>
                    <tr><th>Packaging & Waste</th><td>10/15</td></tr>
                    <tr><th>Sourcing & Supply Chain</th><td>12/15</td></tr>
                    <tr><th>Ethical Labor Practices</th><td>13/15</td></tr>
                    <tr><th>Renewable Energy & Emissions</th><td>0/10</td></tr>
                    <tr><th>Community & Give Back</th><td>8/10</td></tr>
                    <tr><th>Certifications & Transparency</th><td>4/5</td></tr>
                    <tr><th>Bonus (Workplace)</th><td>3/5</td></tr>
                  </tbody>
                </table>
                <hr />
                <h4>Key Recommendations</h4>
                <p><strong>Short-Term:</strong> Implement renewable energy pilots</p>
                <p><strong>Long-Term:</strong> Shift to carbon-neutral shipping</p>
                <p><strong>Certifications to Pursue:</strong> GOTS, B Corp</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default CertificatePage;
